export const MAX_DOMAIN_VALUE = 10000;
